import { useMutation } from '@ngtrvu/use-api';
import { useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { Button } from 'common/ui/button';
import { PasswordInput } from 'common/ui/password-input';
import {
  ADMIN_ACCOUNT_QUERY_KEY,
  useAdminAccount,
} from 'hooks/use-admin-account';
import { useState } from 'react';
import {
  STAFF_PASSWORD_HINT,
  STAFF_PASSWORD_MIN_LENGTH,
  staffPasswordError,
} from 'utils/password-policy';
import createAccountPasswordApi from '../../../api-calls/create-password';

export default function CreatePassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const { data: account } = useAdminAccount();

  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation(createAccountPasswordApi, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNT_QUERY_KEY });
      notification.open({
        type: 'success',
        message: 'Tạo mật khẩu thành công',
      });
      setPassword('');
      setConfirmPassword('');
    },
    // use-api passes the thrown error; lib/api-call puts the body on .response
    onError: (err: any) => {
      const { error, error_code } = err?.response || {};
      notification.open({
        type: 'error',
        message: `Lỗi: ${error || error_code || err?.message}`,
      });
    },
  });
  const validate = () => {
    const policyError = staffPasswordError(password, account?.email);
    if (policyError) {
      return policyError;
    }
    if (password !== confirmPassword) {
      return 'Mật khẩu nhập lại không khớp.';
    }
    return '';
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }
    mutate({ password });
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
        <h2 className="mb-6 text-2xl font-bold text-center">Tạo mật khẩu</h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block mb-1 font-medium">Mật khẩu mới</label>
            <PasswordInput
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Nhập mật khẩu mới"
              minLength={STAFF_PASSWORD_MIN_LENGTH}
              autoComplete="new-password"
              required
            />
            <p className="mt-1 text-xs text-gray-500">{STAFF_PASSWORD_HINT}</p>
          </div>
          <div>
            <label className="block mb-1 font-medium">Nhập lại mật khẩu</label>
            <PasswordInput
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Nhập lại mật khẩu mới"
              minLength={STAFF_PASSWORD_MIN_LENGTH}
              required
            />
          </div>
          {error && <div className="text-red-500 text-sm">{error}</div>}

          <Button type="submit" className="w-full" disabled={isPending}>
            {isPending ? 'Đang tạo...' : 'Tạo mật khẩu'}
          </Button>
        </form>
      </div>
    </div>
  );
}
